import { computed, action } from 'mobx';
import sessionStore from './session';
import agentStore from './agent';
import sessionIDListStore from './sessionIDList';
import { SessionIDType } from '@/utils/constants';
import { addData } from '@/utils/instantLoaded/toolsWithoutDeps';

class ShowDataStore {
  @computed
  get dataList() {
    let { sessionIDList } = sessionIDListStore;
    sessionIDList = sessionIDList.slice();

    const {
      sessionData,
      initList,
    } = sessionStore;

    const { agentData } = agentStore;

    let dataList = [...initList];
    // Test
    // for (let i = 0; i < 20; i++) {
    //   dataList = [...dataList, ...initList];
    // }

    sessionIDList.forEach((idItem) => {
      const { type, id } = idItem;
      switch (type) {
        case SessionIDType.PRE_INIT_SESSION:
        case SessionIDType.CHAT_BOT:
          dataList = addData(dataList, sessionData, id);
          break;
        case SessionIDType.AGENT:
          // [live-chat-split-change]
          dataList = dataList.concat({ form: 'agent', sessionId: id });
          break;
        default:
      }
    });

    return dataList;
  }

  @computed
  get dataListLength() {
    return this.dataList.length;
  }
}

const showDataStore = new ShowDataStore();

export default showDataStore;
